import React from 'react';
import { Link } from 'react-router-dom';

export default function ConfigurationSidebar() {
    return (
        <div className="nested-menu">
            <div className="menu-title mb-2">
                <p>Configuration</p>
            </div>
            <div className="menu-items">
                <ul>
                    <li>
                        <Link to="/admin/survey/create/configuration/" className='active'>General</Link>
                    </li>
                    <li>
                        <Link to="/admin/survey/webhooks/">Webhooks</Link>
                    </li>
                </ul>
            </div>


        </div>
    )
}
